var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { HttpClient, HttpParams } from '@angular/common/http';
import { disabledProgress } from '../../config/progress.inteceptor';
import { map } from 'rxjs/operators';
var MsisdnService = /** @class */ (function () {
    function MsisdnService(http) {
        this.http = http;
    }
    MsisdnService.prototype.msisdns = function () {
        return this.http.get('/msisdns');
    };
    MsisdnService.prototype.historicalMsisdns = function () {
        return this.http.get('/record-events/historical-msisdns');
    };
    MsisdnService.prototype.inboundableMsisdns = function () {
        return this.http.get('/msisdns/inboundable');
    };
    MsisdnService.prototype.limitsExceeded = function () {
        return this.http
            .get('/msisdns/limits-exceeded')
            .pipe(map(function (response) { return response.limitsExceeded; }));
    };
    MsisdnService.prototype.projectNumbers = function (projectId) {
        return this.http.get("/projects/" + projectId + "/numbers");
    };
    MsisdnService.prototype.updateLabel = function (id, body) {
        return this.http.put("/msisdns/" + id, body);
    };
    MsisdnService.prototype.updateRecordingEnabled = function (id, body) {
        return this.http.put("/msisdns/" + id + "/recording", body).toPromise();
    };
    MsisdnService.prototype.assign = function (request) {
        return this.http.post('/msisdns/assign', request);
    };
    MsisdnService.prototype.assignInitial = function (request) {
        return this.http.post('/msisdns/assign-initial', request);
    };
    MsisdnService.prototype.isLabelExisting = function (label) {
        var httpParams = new HttpParams({
            fromObject: {
                label: label
            }
        });
        return this.http.get("/msisdns/exists", __assign({ params: httpParams }, disabledProgress));
    };
    return MsisdnService;
}());
export { MsisdnService };
